import { useEffect, useState } from 'react';
import { useAuctionStore } from '../stores/auction';
import AuctionCard from '../components/AuctionCard';
import { AUCTION_CATEGORIES, type AuctionCategory } from '@auction/shared';

const statuses = [
  { key: '', label: 'All' },
  { key: 'active', label: 'Active' },
  { key: 'ending', label: 'Ending Soon' },
  { key: 'closed', label: 'Closed' },
  { key: 'sold', label: 'Sold' },
];

export default function HomePage() {
  const { auctions, loading, error, fetchAuctions, selectedCategory, setSelectedCategory } = useAuctionStore();
  const [filter, setFilter] = useState('');

  useEffect(() => {
    fetchAuctions(filter || undefined, selectedCategory);
  }, [filter, selectedCategory, fetchAuctions]);

  return (
    <div>
      <div className="flex flex-col gap-4 mb-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">Live Auctions</h1>
          <div className="flex space-x-2">
            {statuses.map((s) => (
              <button
                key={s.key}
                onClick={() => setFilter(s.key)}
                className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                  filter === s.key
                    ? 'bg-primary-600 text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {s.label}
              </button>
            ))}
          </div>
        </div>
        
        {/* Category filter */}
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => setSelectedCategory(null)}
            className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
              selectedCategory === null
                ? 'bg-secondary-600 text-white'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            All Categories
          </button>
          {AUCTION_CATEGORIES.map((cat) => (
            <button
              key={cat.value}
              onClick={() => setSelectedCategory(cat.value as AuctionCategory)}
              className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${
                selectedCategory === cat.value
                  ? 'bg-secondary-600 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>
      </div>

      {loading && (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
        </div>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
          {error}
        </div>
      )}

      {!loading && auctions.length === 0 && (
        <div className="text-center py-12">
          <p className="text-gray-500 text-lg">No auctions found.</p>
          <p className="text-gray-400 mt-2">Try the Demo Panel to create some sample auctions!</p>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {auctions.map((auction) => (
          <AuctionCard key={auction.id} auction={auction} />
        ))}
      </div>
    </div>
  );
}
